import type { SxStyle } from '@aibees/shared/theme';
import { CSSProperties } from 'react';

export const root: SxStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
};

export const name: SxStyle = {
  textDecoration: 'none',
};

export const img: CSSProperties = { width: '100%', height: 'auto' };

export const infoWrapper: SxStyle = {
  flex: 1,
  minWidth: 0,
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  overflow: 'hidden',
  width: '100%',
  gap: '2px',
};

export const nameRow: SxStyle = {
  gap: 0.5,
  overflow: 'hidden',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
};

export const lastUpdate: SxStyle = {
  display: 'none',
};
